import * as React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material";
import { alpha } from "@mui/material";
import { useNavigate } from "react-router";
import { dashboardRoute } from "../../routes/reactRoutes";
import { LockPersonOutlined } from "@mui/icons-material";
import drawerDim  from  "../../theme/drawerDimensions";
import { t } from "i18next";

export default function UnAuthorized() {
  //styling
  const theme = useTheme();
  const navigate = useNavigate();
  const divStyle = {
    display: "flex",
    p: 2,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    // Use full viewport height/width so unauthorized screen doesn't leave whitespace
    // when rendered outside the main app layout (e.g., invite URL tampering).
    minHeight: "100vh",
    width: "100vw",
    boxSizing: "border-box",
    background: alpha(theme.palette.primary.main, 0.15),
  };

  //end styling
  const handleHomePageClick = () => {
    navigate(dashboardRoute);
  };

  return (
    <Box sx={divStyle}>
      <LockPersonOutlined
        color="primary"
        sx={{ width: "200px", height: "200px" }}
      ></LockPersonOutlined>
      <Typography sx={{ fontSize: "2rem", color: theme.palette.primary.main }}>
        {t("unauthorized")}
      </Typography>
      <Typography
        sx={{ fontWeight: 400, mb: 2.5, color: theme.palette.primary.main }}
      >
        {t("nopermission")}
      </Typography>
      <Button
        variant="contained"
        onClick={handleHomePageClick}
        sx={{ width: "300px", textTransform: "none", fontSize: 18 }}
      >
        {t("gohomepage")}
      </Button>
    </Box>
  );
}
